export enum EmployerFeedAction {
    userAssignedAsJobReviewer = 'userAssignedAsJobReviewer',
    userAcceptedInvite = 'userAcceptedInvite',
    reviewerMentionedInComment = 'reviewerMentionedInComment',
    matchWaitingInStage = 'matchWaitingInStage',
    employerUserAccessRequest = 'employerUserAccessRequest',
}
